import { createAction } from '@reduxjs/toolkit';

export const updateLocalCartState = createAction<{ shipMethodId: string }>('CART/UPDATE_LOCAL_CART_SHIPPING_STATE');
